<div class="footer__block">
  <div class="footer__heading heading heading_small">Download App</div>
  <div class="footer__apps">
    <a target="_blank" class="inactive">
      <img
        src="assets/appstore.svg"
        width="2500"
        height="741"
        alt="App Store"
        loading="lazy"
      />
      <span>Coming Soon</span>
    </a>
    <a target="_blank" class="inactive">
      <img
        src="assets/googleplay.svg"
        width="5435.8"
        height="1604"
        alt="Google Play"
        loading="lazy"
      />
      <span>Coming Soon</span>
    </a>
  </div>
</div>
